import perfil from '@/helpers/perfil.js';
import usuarioHelper from '@/helpers/usuario.js';

export default {
    Home: {
        acesso: true
    },
    Login: {
        acesso: true
    },
    ErroPaginaNaoEncontrada: {
        acesso: true
    },
    SideMenu: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.franquiado,
        telaUsuarioBtn: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.franquiado
    },
    RecuperarSenha: {
        acesso: true
    },
    EsqueciSenha: {
        acesso: true
    },
    Portal: {
        acesso: true
    },
    Usuarios: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.franquiado || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.clienteMetta,
        editarUsuarios: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.clienteMetta
    },
    CadastroUsuario: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.franquiado || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.clienteMetta,
    },
    Contas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    CadastroConta: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    Empresas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CadastroEmpresa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    StatusEmpresa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    Origens: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    CadastroOrigem: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    Segmentos: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    CadastroSegmento: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    Pessoas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    PessoasAniversariantes: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CadastroPessoa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    StatusPessoa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    Agendas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    AgendaLista: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    NegociosEmpresa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    NegociosPessoa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    NegociosPessoaPrimeiroContato: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    NegociosPessoaPosVenda: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    DocumentosEmpresa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    DocumentosPessoa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador
    },
    Produtos: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.franquiado || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador,
    },
    CadastroProduto: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.franquiado || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador,
    },
    Caixa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    HistoricoCaxia: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    EditarCaixa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    Despesas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CadastroDespesa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CaixaDiario: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CaixaDiarioCompleto: { 
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CaixaMensal: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CustoDiario: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CustoMensal: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    ProdutosMaisVendidos: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    CustoVSReceita: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario > perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    VendasSite: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario >= perfil.ID.operador  && usuarioHelper.USUARIO_LOGADO().idtipousuario != perfil.ID.bioMedicina
    },
    TipoDespesas: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.franquiado || usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador,
    },
    CadastroTipoDespesa: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.administrador
    },
    Download: {
        acesso: usuarioHelper.USUARIO_LOGADO().idtipousuario == perfil.ID.clienteMetta
    }
}


// WEBPACK FOOTER //
// ./src/helpers/permissoes.js